import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Analise from "./pages/Analise";
import DetailsProposal from "./pages/DetailsProposal";
import Precatorios from "./pages/Precatorios";
import { getInfos, isAdmin } from "./auth";
import AuthenticatedLayout from "./components/AuthenticatedLayout";
import DetailsAnaliseJuridica from "./pages/DetailsAnaliseJuridica";
import DetailsAnaliseFinanceira from "./pages/DetailsAnaliseFinanceira";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  const isAuthenticated = !!getInfos();

  return (
    <Router>
      <ToastContainer autoClose={3000} />
      <Routes>
        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Navigate to="/precatorios" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/"
          element={<Navigate to={isAuthenticated ? "/analise" : "/login"} />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/analise"
          element={
            isAuthenticated ? (
              <AuthenticatedLayout>
                <Analise />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/detailsProposal/:id"
          element={
            isAuthenticated ? (
              <AuthenticatedLayout>
                <DetailsProposal />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/detailsAnaliseJuridica/:id"
          element={
            isAuthenticated ? (
              <AuthenticatedLayout>
                <DetailsAnaliseJuridica />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/detailsAnaliseFinanceira/:id"
          element={
            isAuthenticated ? (
              <AuthenticatedLayout>
                <DetailsAnaliseFinanceira />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        <Route
          path="/precatorios"
          element={
            isAuthenticated ? (
              <AuthenticatedLayout>
                <Precatorios />
              </AuthenticatedLayout>
            ) : (
              <Navigate to="/analise" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

/*  
  APRESENTAÇÃO FINAL:
    ⦁	GERAR PROPOSTA
     	- Darci

    ⦁	REPROVAR na análise FINANCEIRA
      - Luciano
        - MOTIVO: Não lucrativo

    ⦁	REPROVAR na análise JURÍDICA
      - Roseli 		
        - MOTIVO: Análise consta sim o termo "Embargos à Execução"
*/
